<template>
  <div class="editCube">
    <div><label :for="keyname2"><input type="checkbox" :id="keyname2" v-model="data2" @change="updateBookable(keyname2, $event.target.checked)">{{title}}</label><button class="editBtn" @click="setEdit"></button></div>
    <div class="opts" v-if="data&&data2">
      <div v-for="(opt, o) in data" :key="`opt-${o}`" class="opt">{{opt}}</div>
    </div>
    <template v-if="edit">
      <div class="dialogBg">
        <div class="cube" :label="title">
        <div class="closeBtn" @click="edit=false"></div>
        <div class="griddate">
          <div v-for="(dt, d) in datainput" :key="`date-${d}`">
            <input type="text" v-model="datainput[d]">
          </div>
        </div>
        <div class="btns" v-if="edit">
          <button class="cancel" @click="edit=false">取消</button>
          <button class="confirm" @click="udpateData">儲存</button>
        </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getapi, postapi } from '../store/fetch'
export default {
  props: ['title', 'keyname', 'keyname2'],
  data () {
    return {
      edit: false,
      data: [
        '11:00'
      ],
      data2: false,
      datainput: [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      ]
    }
  },
  async mounted () {
    this.datainput = [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    ]
    this.data = await getapi(`selections/${this.keyname}`)
    this.data2 = await getapi(`selections/${this.keyname2}`)
    if (this.data === false) {
      await postapi(`selections/${this.keyname}`, { key: 'options', data: [] })
      this.data = await getapi(`selections/${this.keyname}`)
    }
  },
  methods: {
    setEdit () {
      this.datainput = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      ]
      this.data.forEach((e, i) => {
        this.datainput[i] = e
      })
      this.edit = true
    },
    async getdata () {
      this.data = await getapi(`selections/${this.keyname}`)
      if (this.data === false) {
        await postapi(`selections/${this.keyname}`, { key: 'options', data: [] })
        this.data = await getapi(`selections/${this.keyname}`)
      }
    },
    async updateBookable (keyname2, value) {
      this.data2 = await postapi(`selections/${keyname2}`, { key: 'bool', data: value })
      this.$emit('update2', value)
    },
    async udpateData () {
      this.data = await postapi(`selections/${this.keyname}`, { key: 'options', data: this.datainput.filter(e => e) })
      this.edit = false
      this.$emit('update', this.data)
    }
  }

}
</script>

<style lang="scss" scoped>
.editCube {
  label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    gap: 8px;
    align-items: center;
  }
  input[type=checkbox] {
    position: relative;
    appearance: none;
    width: 24px;
    height: 24px;
    margin-bottom: 8px;
    &::before {
      border-radius: 50%;
      border: 2px solid var(--color-pri);
      display: inline-block;
      width: 24px;
      height: 24px;
      background-color: #FFFFFF;
      content: '';
      margin-right: 8px;
    }
    &:checked::before {
      background-color: var(--color-checked);
    }
    &:checked::after {
      content: '';
      display: inline-block;
      position: absolute;
      left: 6px;
      top: 8px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #FFFFFF;
    }
  }
}
.griddate {
  padding: 14px 15px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  &>:nth-child(odd) {
    border: 1px solid var(--color-border);
    border-top: none;
    padding: 2px;
    box-sizing: border-box;
  }
  &>:nth-child(even) {
    border: 1px solid var(--color-border);
    border-left: none;
    border-top: none;
    padding: 2px;
    box-sizing: border-box;
  }
  &>:nth-child(1),&>:nth-child(2) {
    border-top: 1px solid var(--color-border);
  }
  &>div>input {
    height: 38px;
    border: none;
    width: calc(100% - 2px);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
    text-align: center;

  }
}
.closeBtn {
  position: absolute;
  top: 9px;
  right: 9px;
  width: 30px;
  height: 30.28px;
  background-color: #FFFFFF;
  mask-image: url(./close.svg);
  mask-size: contain;
  border: none;
  mask-repeat: no-repeat;
  box-sizing: border-box;
}
.cube {
  position: relative;
  width: 375px;
  height: 695px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  &::before {
    content: attr(label);
    display: inline-flex;
    width: 100%;
    height: 55px;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    letter-spacing: 0.1em;
    background-color: var(--color-checked);
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px 5px 0 0;
  }
}
.dialogBg {
  z-index: 100;
  position: absolute;
  backdrop-filter: blur(3px);
  background-color: #99999933;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.opts {
  margin-block: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.opt {
width: 100px;
height: 55px;
border: 1.5px solid var(--color-checked);
box-sizing: border-box;
border-radius: 5px;
display: flex;
align-items: center;
justify-content: center;
font-family: 'Roboto';
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 23px;
letter-spacing: 0.1em;
}
.editCube {
  margin: 0;
  margin-bottom: 20px;
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 9px;
  textarea, p {
    margin: 0;
    height: 200px;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 67px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: -webkit-fill-available;
    input {
      width: 100px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 3px;
      border: 1px solid var(--color-border);
      margin-inline: 9px;
      text-align: center;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 900;
      font-size: 18px;
      text-align: center;
      letter-spacing: 0.1em;
      color: var(--color-confirm);
    }
  }
  &>div:nth-child(1) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(./pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}

</style>
